<template>
  <div class="container">
    <h1 style="position:absolute; top: 42vh;" class="page-title">Dashboard</h1>
    <div class="dashboard-area" style="min-width: 1280px">
      <div class="row">
        <div class="col-sm-4 mb-2">
          <div class="card core-card-container">
            <router-link tag="div" to="/HR/hrpersonel" class="card-body text-start text-decoration-none">
              <h5 class="card-title">HR Employee<i class="icon icon-users"></i></h5>
              <p class="card-text">You can check HR Employee</p>
            </router-link>
          </div>
        </div>
        <div class="col-sm-4 mb-2">
          <div class="card core-card-container">
            <router-link tag="div" to="/HR/hrpersonelpassport" class="card-body text-start text-decoration-none">
              <h5 class="card-title">All Passport Report<i class="icon icon-users"></i></h5>
              <p class="card-text">You can check passport report</p>
            </router-link>
          </div>
        </div>
        <div class="col-sm-4 mb-2">
          <div class="card core-card-container">
            <router-link tag="div" to="/DAI-Gendec/daily-crew-schedule" class="card-body text-start text-decoration-none">
              <h5 class="card-title">Daily Crew Schedule <i class="icon icon-plane-solid"></i></h5>
              <p class="card-text">You can check Flight Information and Crew List</p>
            </router-link>
          </div>
        </div>
        <div class="col-sm-4 mb-2">
          <div class="card core-card-container">
            <router-link tag="div" to="/DAI-Gendec/gendec" class="card-body text-start text-decoration-none">
              <h5 class="card-title">Gendec Reports <i class="icon icon-file-pdf-solid"></i></h5>
              <p class="card-text">You can check General Declaration</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "DashBoard",
  created() {

  }
}
</script>

<style scoped>
.card{
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}
.card-body{
  padding: 25px;
  min-height: 130px;
}
.card-body:hover{
  color: #000;
}
.card:hover{
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  transition: .3s;
}
.card-title{
  font-family: NunitoBold;
  display: flex;
  justify-content: space-between;
}
.card-title i{
  color: #d51317;
}
</style>
